// Libraries
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

// Components
import { ContentWrap as SContentWrap } from '../../style'

export const Wrap = styled.footer`
  width: 100%;
  background: #283B56;
`;

export const ContentWrap = styled(SContentWrap)`
  display: flex;
  text-align: center;
  flex-direction: column;
  padding: 30px 0 18px 0;
`;

export const FooterLogo = styled(motion.img)`
  margin-bottom: 20px;
  align-self: center;
  :hover {
    cursor: pointer;
  }
`;

export const WrapLink = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  column-gap: 20px;
  text-decoration: underline;
  margin-bottom: 1rem;
`;

export const Hr = styled(motion.hr)`
  width: 100%;
  margin: 20px 0;
  color: #fff;
  border-top: 1px;
`;

export const SmallText = styled.p`
  width: 700px;
  //display: block;
  align-self: center;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      width: 521px;
    }
    ${theme.media.tablet} {
      width: 95%;
    }
  `}
  margin: 0;
  font-size: 14px;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 16px;
`;

export const Vertical = styled.div`
  width: 1px;
  height: 16px;
  background-color: #fff;
`;
